var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"file",attrs:{"type":"file","name":"filename"}}),_c('v-btn',{on:{"click":_vm.upload}},[_vm._v("Upload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }